import firebase from './fb'
const db=firebase.firestore();
export default db;